import { assign, freeze } from 'icepick';
import noop from 'lodash/noop';
import { SET_APP_PROPS, type SetAppPropsAction } from '../actions/app-props.tsx';
import type { CallbacksState } from './types.tsx';

type Action = SetAppPropsAction;

export const initialState: CallbacksState = freeze({
	onIssueCountFetched: noop,
	onSuccessful: noop,
	onFail: noop,
	onDialogDisplay: noop,
	onDialogCancel: noop,
});

const callbacks = (state: CallbacksState = initialState, action: Action): CallbacksState => {
	switch (action.type) {
		case SET_APP_PROPS: {
			return assign(state, action.payload.callbacks);
		}
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};

export default callbacks;
